import React from 'react';
import { Link } from 'react-router-dom';
import './QualityCertification.css';

const QualityCertification = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <h1 className="page-title">Quality Certification</h1>
            <div className="page-text-content">
              <p>
                Quality Certification encompasses a broad range of certification services focused on 
                ensuring products, processes, and services meet specific quality, safety, and 
                performance standards. At NQC (Nova Quality Certification Agency), we provide 
                comprehensive quality certification services to help businesses demonstrate their 
                commitment to excellence and gain competitive advantages.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is Quality Certification?</h2>
            <div className="page-text-content">
              <p>
                Quality Certification involves the evaluation and verification of products, processes, 
                or services against established quality standards and specifications. These 
                certifications provide independent assurance that quality requirements are met, 
                helping businesses build trust with customers and stakeholders.
              </p>
              <p>
                Quality certifications cover various aspects including product safety, environmental 
                compliance, manufacturing practices, hygiene standards, and specialized industry 
                requirements. They serve as evidence of a company's commitment to quality and 
                continuous improvement.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Benefits of Quality Certification</h2>
            <div className="benefits-list">
              <div className="benefit-item">
                <h3 className="benefit-title">1. Quality Assurance</h3>
                <p className="benefit-description">
                  Quality certification provides independent verification that your products and 
                  processes meet established quality standards, ensuring consistency and reliability.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">2. Customer Trust</h3>
                <p className="benefit-description">
                  Certified products and services build customer confidence and trust, leading to 
                  increased customer satisfaction and loyalty.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">3. Regulatory Compliance</h3>
                <p className="benefit-description">
                  Quality certifications help ensure compliance with industry regulations and 
                  standards, reducing legal risks and ensuring market access.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">4. Process Improvement</h3>
                <p className="benefit-description">
                  The certification process helps identify areas for improvement, leading to more 
                  efficient processes and better product quality.
                </p>
              </div>
              <div className="benefit-item">
                <h3 className="benefit-title">5. Market Differentiation</h3>
                <p className="benefit-description">
                  Quality certification distinguishes your products and services from competitors, 
                  providing a competitive edge in the marketplace.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Our Quality Certification Services</h2>
            <div className="page-text-content">
              <p>
                NQC offers a comprehensive range of quality certification services:
              </p>
            </div>
            <div className="services-grid">
              <div className="service-card">
                <h3 className="service-card-title">ROHS Certificate</h3>
                <p className="service-card-description">
                  ROHS certification ensures compliance with restrictions on hazardous substances in 
                  electronic and electrical equipment, promoting environmental protection and product 
                  safety.
                </p>
                <Link to="/rohs-certificate" className="service-link">Learn More →</Link>
              </div>
              <div className="service-card">
                <h3 className="service-card-title">AS 9100 Certificate</h3>
                <p className="service-card-description">
                  AS 9100 certification demonstrates quality management system compliance for the 
                  aerospace, space, and defense industries.
                </p>
                <Link to="/as-9100" className="service-link">Learn More →</Link>
              </div>
              <div className="service-card">
                <h3 className="service-card-title">GHP Certificate</h3>
                <p className="service-card-description">
                  Good Hygiene Practices certification verifies compliance with hygiene standards in 
                  food production and processing, ensuring food safety and quality.
                </p>
                <Link to="/ghp-certificate" className="service-link">Learn More →</Link>
              </div>
              <div className="service-card">
                <h3 className="service-card-title">GMP Certificate</h3>
                <p className="service-card-description">
                  Good Manufacturing Practices certification ensures products are manufactured 
                  according to quality, safety, and effectiveness standards in pharmaceuticals, 
                  food, and cosmetics.
                </p>
                <Link to="/gmp-certificate" className="service-link">Learn More →</Link>
              </div>
              <div className="service-card">
                <h3 className="service-card-title">WRAS Certificate</h3>
                <p className="service-card-description">
                  WRAS certification confirms compliance with water regulations in England and Wales, 
                  ensuring plumbing products are safe and suitable for use in water systems.
                </p>
                <Link to="/wras-certificate" className="service-link">Learn More →</Link>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Certification Process</h2>
            <div className="process-list">
              <div className="process-item">
                <h3 className="process-title">1. Initial Consultation</h3>
                <p className="process-description">
                  We begin with a consultation to understand your products, processes, and 
                  certification requirements.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">2. Documentation Review</h3>
                <p className="process-description">
                  Our experts review your documentation and procedures to assess current compliance 
                  with quality standards.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">3. Testing & Evaluation</h3>
                <p className="process-description">
                  Products and processes undergo testing and evaluation to verify compliance with 
                  applicable quality standards.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">4. On-Site Assessment</h3>
                <p className="process-description">
                  Our auditors conduct on-site assessments of facilities and processes to ensure 
                  quality standards are met.
                </p>
              </div>
              <div className="process-item">
                <h3 className="process-title">5. Certification & Support</h3>
                <p className="process-description">
                  Upon successful completion, you receive your quality certification. We provide 
                  ongoing support and surveillance to maintain certification.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC?</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) is dedicated to providing exceptional quality 
                certification services. Our experienced team understands the importance of quality in 
                today's competitive marketplace and works closely with clients to ensure successful 
                certification outcomes.
              </p>
              <p>
                We offer comprehensive support throughout the certification process, from initial 
                consultation to ongoing maintenance. Contact us today to learn more about our quality 
                certification services and how we can help your business achieve its quality goals.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default QualityCertification;

